import * as yup from 'yup';
const validationSchema = yup.object({
  name: yup
    .string()
    .min(1, 'First name should be min 1 characters')
    .required('Name required'),
});

export default validationSchema;
